<template>

    <NextSottoProgettoTable
            class="rotate-x-180 w-full border-separate"
            actionClass="relative"
            nuvola_td_class="border-next-light-gray"
            alternativa_td_class="border-next-light-gray"
            :seleectable="true"
            :cols="TableHeader"
            @update:cols="syncUserPreference"
            :rows="ordered_records"

    >
        <template v-for="(rc, i) in ordered_records" v-slot:[`td_${i}_preactions`]="{row}">
            <slot :name="`td_${i}_preactions`" v-bind="{row: row}">
            </slot>
        </template>

        <template v-for="(rc, x) in rowCellIterator(ordered_records, sottoProgettiCols)"
                  :key="x"
                  v-slot:[`td_${rc}`]="{row, cell}">
            <Text>{{ getValue(row, cell) }}</Text>
        </template>
    </NextSottoProgettoTable>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import {mapActions, mapGetters, mapState} from 'vuex';
import fornitoriManager from "../api/FornitoriManager";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import DynamicCell from "@/components/DynamicCell.vue";
import NextSottoProgettoTable from "@/components/NextSottoProgettoTable.vue";
import Empty from "@/components/Empty.vue";
import Text from "@/components/Text.vue";

@Options({
    name: 'OffertaTable',
    components: {
        Text,
        Empty,
        NextSottoProgettoTable,
        DynamicCell
    },
    inject: ['getColoreStato', 'getLabelStato'],
    props: {
        id: String,
        readonly: {
            type: Boolean,
            default: false
        },
        ordered_records: {
            type: Array,
            default: []
        }
    },
    computed: {
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('buFieldModule', [
            'tableHeader',
            'computedUserPreference',
            'sortedAllField',
            'OrderedRows',
            'isCellAcquisto',
            'isCellVendita',
            'isCellRe',
            'isCellNe',
        ]),
        ...mapGetters('sprjDataManager', [
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'AcCostoTotaleEuro',
            'VeBudget',
            'VeBudgetEuro',
            'BudgetLordoIva',
            'Mol',
            'Utile',
            'CostoVenditaUnitario',
            'TotaleCosti',
            'TotaleUtili',
            'TotaleRicaviProgetto',
            'TotaleRisorseInterne',
            'TotaleMol',
            'getValuta',
        ]),
    },
    methods: {
        ...mapActions('buFieldModule', [
            'fetchSottoprogettoUserPreference',
            'updateTableHeader',
            'toggleFieldVisibility',
            'orderChange',
        ]),
    }
})
export default class OffertaTable extends Vue {
    AcCostoUnitarioNetto: any
    toggleFieldVisibility: any
    isCellAcquisto: any
    isCellVendita: any
    isCellRe: any
    tableHeader: any
    AcCostoTotale: any
    AcCostoTotaleEuro: any
    VeBudget: any
    VeBudgetEuro: any
    BudgetLordoIva: any
    Mol: any
    Utile: any
    CostoVenditaUnitario: any
    TotaleCosti: any
    TotaleRisorseInterne: any
    TotaleUtili: any
    TotaleRicaviProgetto: any
    TotaleMol: any
    getValuta: any

    id!: number | string
    topbar = Topbar

    cmOpener: any = setup(() => ContextMenuOpener())
    cm_visible = false

    private sottoProgettiCols: any;

    hasNuvole(row: any) {
        return row.nuvole
    }

    get TableHeader() {
        return this.tableHeader.map((h: any) => {
            return {...h, td_class: this.getClass(h)}
        })
    }

    syncUserPreference($event: any[]) {
        const _cols = $event.map((el: any) => {
            return {prop: el.prop, visible: el.visible, width: el.width}
        })
        //@ts-ignore
        this.$store.dispatch('buFieldModule/updateTableHeader', _cols)
    }

    getClass(h:any){
        if(this.isCellVendita(h.type)){
            return "bg-next-vendita whitespace-nowrap"
        }
        if(this.isCellAcquisto(h.type)){
            return "bg-next-acquisto whitespace-nowrap"
        }
        if(this.isCellRe(h.type)){
            return "bg-next-margine whitespace-nowrap"
        }
        return "bg-white"
    }

    isText(component: string) {
        return component === 'Text'
    }

    LabelValutaAcquisto(row:any){
        return this.getValuta(row['ac_valuta'])?.valuta?.CG08_SIGLA || '€'
    }
    LabelValutaVendita(row:any){
        return this.getValuta(row['ve_valuta'])?.valuta?.CG08_SIGLA || '€'
    }


    getValue(row: any, cell: any) {
        switch (cell.prop) {
            case 'ac_mark_up':
                //@ts-ignore
                return `${Number(row[cell.prop]).toCurrencyString()} %`
            case 'ac_costo_unitario_netto':
                return `${this.AcCostoUnitarioNetto(row).toCurrencyString()} ${this.LabelValutaAcquisto(row)}`
            case 'ac_costo_totale':
                return `${this.AcCostoTotale(row).toCurrencyString()} ${this.LabelValutaAcquisto(row)}`
            case 'ac_costo_totale_e':
                return `${this.AcCostoTotaleEuro(row).toCurrencyString()} €`
            case 've_budget':
                return `${this.VeBudget(row).toCurrencyString()} ${this.LabelValutaVendita(row)}`
            case 've_budget_lordo_iva':
                return `${this.BudgetLordoIva(row).toCurrencyString()} ${this.LabelValutaVendita(row)}`
            case 're_utile':
                return `${this.Utile(row).toCurrencyString()} €`
            case 've_vendita_unitario':
                //@ts-ignore
                return `${Number(this.CostoVenditaUnitario(row)).toCurrencyString()} ${this.LabelValutaVendita(row)}`
            case 've_budget_e':
                return `${this.VeBudgetEuro(row).toCurrencyString()} €`
            case 're_mol':
                // eslint-disable-next-line no-case-declarations
                const v = this.Mol(row)
                return `${(v ? v : 0).toCurrencyString() || ''} %`
            case 'ac_valuta':
                return this.getValuta(row[cell.prop])?.valuta?.CG08_DESCR
            case 've_valuta':
                return this.getValuta(row[cell.prop])?.valuta?.CG08_DESCR
            case 'ne_fornitore':
                return row[cell.prop]?.denominazione || ''
            case 've_aliquota':
            case 'ne_stato':
            case 'ne_voce_spesa':
            case 'ac_aliquota':
            case 've_fee':
                return row[cell.prop]?.descrizione || ''
            case 'ac_costo_unitario':
                //@ts-ignore
                return `${Number(row[cell.prop]).toCurrencyString()} ${this.LabelValutaAcquisto(row)}`
        }
        return row[cell.prop]
    }

    rowCellIterator(righe: any[], colonne: any[]) {
        const res = []
        for (let i in righe) {
            for (let j in colonne) {
                res.push(`${i}_${colonne[j].prop}`)
            }
        }
        return res
    }

}


</script>


<style lang="scss">

</style>
